

export function colorInsumos(quantidade: number): {bg:string,color:string,level:string} {

    let quantidade_int = parseInt(String(quantidade));
    
    if (quantidade_int >= 100000) return {bg: `rgba(93, 165, 125, 1)`, color: 'white', level: '+100t'};
    if (quantidade_int < 100000 && quantidade_int >= 10000) return {bg: `rgba(93,165,125,0.9)`, color: 'white', level:'+10t'};
    if (quantidade_int < 10000 && quantidade_int >= 1000) return {bg: `rgba(93,165,125,0.8)`, color: 'white',level:'+1t'};

    if (quantidade_int < 1000 && quantidade_int >= 500) return {bg: `rgb(165, 209, 145, 1)`, color: '#227242', level:'+500kg'};
    if (quantidade_int < 500 && quantidade_int >= 100) return {bg: `rgb(165, 209, 145, 0.8)`, color: '#227242', level:'+100kg'};
    if (quantidade_int < 100 && quantidade_int >= 1) return {bg: `rgb(165, 209, 145, 0.6)`, color: '#227242', level:'+1kg'};

    if (quantidade_int < 1) return {bg: `rgb(165, 209, 145, 0.3)`, color: '#227242',level:'< 1kg' };

    return {
        bg: `rgba(93, 165, 125, 1)`,
        color: 'white',
        level:''
    }
};

export function widthInsumos(quantidade: number): string {

    let quantidade_int = parseInt(quantidade.toString());
    
    if (quantidade_int >= 100000) return '100%';
    if (quantidade_int < 100000 && quantidade_int >= 10000) return '95%';
    if (quantidade_int < 10000 && quantidade_int >= 1000) return '85%';

    if (quantidade_int < 1000 && quantidade_int >= 500) return '75%';
    if (quantidade_int < 500 && quantidade_int >= 100) return '65%';
    if (quantidade_int < 100 && quantidade_int >= 1) return '60%';

    if (quantidade_int < 1) return '45%';
    
    return 100+"%"
}